// global.js

import emailjs from '@emailjs/browser'; 

// Define your functions
export async function notification2() { 

  const formData = new FormData(); 
  // formData.append('pageNumber', pageNumber);
  // formData.append('pageSize', pageSize);
   
  try {
    const uploadResponse = await fetch('/api/getnotification', {
      method: 'POST',
      body: formData
    }) 

    if (!uploadResponse.ok) {
      console.error('Failed:', uploadResponse.statusText);
      return;
    } 

    try {
      const data = await uploadResponse.json();  
      // console.log('this array -',data.result); 
      // setNotification(data.result) 
      // setTotalPages(Math.ceil(data.result.count / pageSize))  
    } catch (error) {
        console.error('Error parsing JSON response:', error);
    }

  } catch (error) {
    console.error('Error:', error);
  }
}


export async function notificationMarkAllRead(id){
    

  const formData = new FormData(); 
  formData.append('EmpId', id); 
    
  try {
    const uploadResponse = await fetch('/api/notificationmarkallread', {
      method: 'POST',
      body: formData
    }) 

    if (!uploadResponse.ok) {
      console.error('Failed:', uploadResponse.statusText);
      return;
    } 

    try {
      const data = await uploadResponse.json();    
      // setTotalPages(Math.ceil(data.result.count / pageSize))  
    } catch (error) {
        console.error('Error parsing JSON response:', error);
    }

  } catch (error) {
    console.error('Error:', error);
  }
};

export async function setNotificationAsRead(NotificationID){
    

  const formData = new FormData(); 
  formData.append('NotificationID', NotificationID); 
    
  try {
    const uploadResponse = await fetch('/api/setnotificationasread', {
      method: 'POST',
      body: formData
    }) 

    if (!uploadResponse.ok) {
      console.error('Failed:', uploadResponse.statusText);
      return;
    } 

    try {
      const data = await uploadResponse.json();     
    } catch (error) {
        console.error('Error parsing JSON response:', error);
    }

  } catch (error) {
    console.error('Error:', error);
  }
};

//insert notification
export async function insertNotification(Name, TransactionType, SenderID, ReceiverID, notificationType, SubmissionID){ 

  const formData = new FormData();
  formData.append('EmployeeName', Name);  
  formData.append('TransactionType', TransactionType);  
  formData.append('SenderID', SenderID);  
  formData.append('ReceiverID', ReceiverID);  
  formData.append('NotificationType', notificationType);  
  formData.append('SubmissionID', SubmissionID);   
  try {
    const uploadResponse = await fetch('/api/insertnotification', {
      method: 'POST',
      body: formData
    }) 

    if (!uploadResponse.ok) {
      console.error('Failed:', uploadResponse.statusText);
      return;  
    }   
  } catch (error) {
    console.error('Error:', error);
  }
}; 

// Function to handle form submission (NodeJS version)
export async function sendEmail(type, data) {

  let HrName;
  let HrEmail;
  let cc;
  const TurnAround = /Certification Request/i.test(data.TransactionType)
    ? 'five (5)'
    : 'three (3)';
  
  const formData = new FormData();
  formData.append('facility', data.facility);

  let SurveyLink = "";
  try {
    const uploadResponse = await fetch('/api/gethremails', {
      method: 'POST',
      body: formData,
    });

    if (!uploadResponse.ok) return;

    const pdfResponse = await uploadResponse.json();
    HrName = pdfResponse.result[0].Name;
    HrEmail = pdfResponse.result[0].EmailAddress;
    cc = pdfResponse.result.map(item => item.EmailAddress).join(', ');

  } catch (error) {
    console.error(error);
    return Promise.reject(false);
  }
  // from : sender email
  // to : receiver email
  if (data.facility == 'Manila'){
    HrName = "HR People Helpdesk - Manila";
    HrEmail = "peoplehelpdeskmanila@innodata.com";
    SurveyLink = "https://bit.ly/3szxvfG";
  }else if(data.facility == 'Legazpi'){
    HrName = "HR People Helpdesk - Legazpi";
    HrEmail = "peoplehelpdesklegazpi@innodata.com";
    SurveyLink = "https://forms.office.com/pages/responsepage.aspx?id=NMWSvmB7MEa8AexRIlSNR-UfVB4wqCNIrq4mQIq8JxlURDBVQlJKM1RIMkhDRjRSNUw3UVY2WlJPQi4u";
  } else{
    HrName = "HR People Helpdesk - Cebu";
    HrEmail = "HRComp_Ben@innodata.com";
    SurveyLink = "https://forms.office.com/r/Gha0bdyNKw";
  }
  
  const content = {
    sender_name: HrName,
    sender_email: HrEmail,
    receiver_name: data.Name,
    receiver_email: data.EmailAddress,
    transaction_type: data.TransactionType,
    document_name: data.documentName,
    reason: data.reason,
    stopDeduction: data.stopDeduction,
    cc:cc,
    facility: data.facility,
    turnAround: TurnAround,
    surveyLink: SurveyLink 
  };

  // ONLY DIFFERENCE FROM sendEmail()
  try {
    const result = await sendEmailjs(type, content);
    return result ? Promise.resolve(true) : Promise.reject(false);
  } catch {
    return Promise.reject(false);
  }
}

export async function sendEmailjs(emailType, data) {

  let message = '';
  let title = '';
  const cc = data.cc || `${data.receiver_email}, ${data.sender_email}`;

  // ======================
  // EMAIL TEMPLATES (UNCHANGED)
  // ======================

  const titleComplete = `${data.transaction_type} Approval and Completion Confirmation`;
  const messageComplete = `
  Dear ${data.receiver_name},<br><br>

  We're happy to inform you that your ${data.transaction_type} has been completed.<br>

  We would also like to get your valuable feedback.<br><br>
  Click below to participate in the Customer Satisfaction Survey.<br>
  It will only take a few minutes. 
  <br><br>
  
  Thank you for your support.
  <br><br>

  <a href="${data.surveyLink}"
    style="
      display: inline-block;
      background-color: #0d6efd;
      color: #ffffff;
      padding: 12px 20px;
      text-decoration: none;
      border-radius: 5px; 
      font-weight: bold;
      text-align: left;
    "
    target="_blank">
    Submit a Survey
  </a>

  <br><br>

  Thank you,<br>
  ${data.sender_name}
  `;


  const titleSubmit = `${data.transaction_type}: ${data.receiver_name}`;
  const messageSubmit = `
  We're happy to inform you that your request for ${data.transaction_type} has been successfully submitted. <br>
  
  Your HR CompBen Team will review the submitted documents and will email you <strong>within ${data.turnAround} working days</strong> to update you on the status of your request. <br><br>

  Thank you,<br>

  ${data.sender_name}
  `;

  const titleStopDeduction = `Request to Stop Deduction : ${data.sender_name}`;
  const messageStopDeduction = `
  Your request to stop deduction due to ${data.reason} has been received.<br><br>

  Thank you,<br>

  ${data.receiver_name}
  `;

  const titleResubmit = `Action Required: Resubmission of Document for ${data.transaction_type}`;
  const messageResubmit = `
  Dear ${data.receiver_name},<br><br>

  Please resubmit the ${data.document_name}.<br>
  Reason: ${data.reason}<br><br>

  Thank you,<br>

  ${data.receiver_name}
  `;

  switch (emailType) {
    case 'complete':
      title = titleComplete;
      message = messageComplete;
      break;

    case 'resubmit':
    case 'resubmitted':
      title = titleResubmit;
      message = messageResubmit;
      break;

    case 'submit':
      title = data.stopDeduction ? titleStopDeduction : titleSubmit;
      message = data.stopDeduction ? messageStopDeduction : messageSubmit;
      break;

    default:
      return false;
  }

  // ======================
  // SEND VIA NODEJS
  // ======================

  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        from: {
          name: data.sender_name,
          email: data.sender_email
        },
        to: {
          name: data.receiver_name,
          email: data.receiver_email
        },
        cc,
        subject: title,
        message
      })
    });

    return response.ok;

  } catch (error) {
    console.error('sendEmailjs2 error:', error);
    return false;
  }
}


// Send mail using nodejs mail and smtp


export function add(a, b) {
  return a + b;
}
